import { Card } from '@/components/ui/card';

export default function LegalPage() {
    return (
        <div className="py-10 sm:py-14" data-testid="legal-page">
            <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
                <h1 className="font-[var(--font-display)] tracking-tight text-3xl font-bold text-[var(--brand-navy)] mb-6">Aviso Legal</h1>
                <Card className="p-6 sm:p-8 rounded-xl space-y-5 text-sm text-[hsl(var(--muted-foreground))] leading-relaxed">
                    <section>
                        <h2 className="font-[var(--font-display)] font-semibold text-base text-[hsl(var(--foreground))] mb-2">1. Datos identificativos</h2>
                        <p>En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), se informa:</p>
                        <ul className="list-disc pl-5 mt-2 space-y-1">
                            <li><strong>Razón social:</strong> Auto Sport Gómez S.L.U.</li>
                            <li><strong>Nombre comercial:</strong> ASG Motor</li>
                            <li><strong>NIF:</strong> B06741409</li>
                            <li><strong>Domicilio:</strong> Avenida de Córdoba 15, 06400 Don Benito, Badajoz</li>
                            <li><strong>Teléfono:</strong> +34 627 94 76 22</li>
                            <li><strong>Email:</strong> info@asgmotor.com</li>
                            <li><strong>Sitio web:</strong> https://asgmotor.com</li>
                        </ul>
                    </section>
                    <section>
                        <h2 className="font-[var(--font-display)] font-semibold text-base text-[hsl(var(--foreground))] mb-2">2. Objeto</h2>
                        <p>Este sitio web tiene como finalidad la presentación del inventario de vehículos de ocasión de ASG Motor y facilitar el contacto con potenciales clientes.</p>
                    </section>
                    <section>
                        <h2 className="font-[var(--font-display)] font-semibold text-base text-[hsl(var(--foreground))] mb-2">3. Propiedad intelectual</h2>
                        <p>Todos los contenidos de este sitio web (textos, imágenes, logotipos, dise\u00f1o gráfico) son propiedad de ASG Motor o de sus legítimos titulares. Queda prohibida su reproducción sin autorización expresa.</p>
                    </section>
                    <section>
                        <h2 className="font-[var(--font-display)] font-semibold text-base text-[hsl(var(--foreground))] mb-2">4. Responsabilidad</h2>
                        <p>ASG Motor no se responsabiliza de posibles inexactitudes en la información publicada, que tiene carácter orientativo. Los precios, características y disponibilidad de los vehículos están sujetos a confirmación.</p>
                    </section>
                    <section>
                        <h2 className="font-[var(--font-display)] font-semibold text-base text-[hsl(var(--foreground))] mb-2">5. Legislación aplicable</h2>
                        <p>Este aviso legal se rige por la legislación espa\u00f1ola vigente. Para cualquier controversia serán competentes los Juzgados y Tribunales de Badajoz.</p>
                    </section>
                </Card>
            </div>
        </div>
    );
}
